import script from "./SegmentPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentPopup.vue?vue&type=script&setup=true&lang=js"

import "./SegmentPopup.vue?vue&type=style&index=0&id=3cdeced8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cdeced8"]])

export default __exports__